<template>
    <ion-app>
        <ion-content padding>
            <el-card style="max-width: 900px; margin: 0 auto;">
                <b-container>
                    <b-row>
                        <b-col>
                            <img
                                alt="Logo"
                                class="m-3"
                                style="margin: 0 auto; max-width: 250px;"
                                src="@/assets/img/Logo-Fachverband_Fliesen_und_Naturstein.jpg"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="d-flex justify-content-center">
                        <h2 class="mb-4">Willkommen</h2>
                        <p style="font-weight: 500; letter-spacing: 1px;">
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
                            et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
                            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                            diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                            voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd
                            gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                        </p>
                    </b-row>
                </b-container>
            </el-card>
        </ion-content>
    </ion-app>
</template>

<script>
export default {
    name: 'Start',
    components: {},
    props: {},
    data() {
        return {
            savedSheets: ['Kachelverband Handbuch 2019', 'Kachelverband Cheatsheet', 'Kachelverband Super Buch'],
            cloudSheets: ['Kachelverband Handbuch 2020'],
            dialogVisible: false,
        };
    },
    computed: {},
    mounted() {},
    methods: {
        viewPDF(sheet) {
            this.$router.push('/view');
        },
        showLogout() {
            this.dialogVisible = true;
        },
        backbutton() {
            this.dialogVisible = false;
            this.$router.push('/');
        },
    },
};
</script>
